module.exports = __webpack_public_path__ + "img/m1.b1f10fef.png";